import { API_ENDPOINTS, withParams } from '../config/apis';
import { apiRequest } from '../api/client';

/** 대회에 배정된 리더기 — 백엔드 EventReaderDeviceResponse */
export type EventReaderDevice = {
  readerDeviceId: number;
  code: string;
  /** 'CONNECTED' | 'STOPPED' | null */
  connection: string | null;
  battery: number | null;
  /** R1/R2 안테나 동작 여부 (백엔드가 'reading' 여부로 판정) */
  r1: boolean;
  r2: boolean;
  /** R3/R4 안테나 동작 여부. 4리더 모델(F2000/F2060/F860PRO)만 보내며, 2리더 모델은 null */
  r3: boolean | null;
  r4: boolean | null;
  timingPointName: string | null;
  /** 현재 대회에 매핑(활성)됐는지 = ON/OFF 토글 상태 */
  mapped: boolean;
  /** 리더기가 실제로 마지막에 config(.ecg)를 내려받아 확인한 대회 ID. 한 번도 받은 적 없으면 null */
  lastConfigFetchedEventId: number | null;
};

export const eventReaderDeviceService = {
  list: (eventId: number) =>
    apiRequest<{ readerDevices: EventReaderDevice[] }>(
      withParams(API_ENDPOINTS.eventReaderDeviceList, { eventId })
    ).then((res) => res.readerDevices),

  add: (eventId: number, readerDeviceIds: number[]) =>
    apiRequest<void>(
      withParams(API_ENDPOINTS.eventReaderDeviceCreate, { eventId }),
      { body: { readerDeviceIds } }
    ),

  updateTimingPoint: (eventId: number, readerDeviceId: number, timingPointId: number | null) =>
    apiRequest<{ eventId: number; readerDeviceId: number; timingPointId: number | null }>(
      withParams(API_ENDPOINTS.eventReaderDeviceTimingPointUpdate, { eventId, readerDeviceId }),
      { body: { timingPointId } }
    ),

  setConfig: (eventId: number, readerDeviceId: number, active: boolean) =>
    apiRequest<void>(
      withParams(API_ENDPOINTS.readerDeviceCurrentEventSet, { eventId, readerDeviceId }),
      { query: { active } }
    ),

  remove: (eventId: number, readerDeviceId: number) =>
    apiRequest<void>(
      withParams(API_ENDPOINTS.eventReaderDeviceDelete, { eventId, readerDeviceId })
    ),

  activateAll: (eventId: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.eventReaderDevicesActivate, { eventId })),

  deactivateAll: (eventId: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.eventReaderDevicesDeactivate, { eventId })),
};
